import { saveAs } from "file-saver";
import { ActionFunctionArgs, LoaderFunctionArgs, redirect } from "react-router-dom";

import { myAxios } from "src/components/common/functions";
import { appendField } from "../common/FilterFrame/FilterField";
import { buildDefaultState } from "../common/FilterFrame/FilterModal";
import { extraFields } from "./ServiceList";
import { fields } from "./ServiceFilterForm";

export async function servicesLoader({ request }: LoaderFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const url = new URL(request.url);
    let shouldRedirect = false;
    for (const [key] of url.searchParams) {
        if (![...Object.keys(buildDefaultState(fields)), ...extraFields].includes(key)) {
            url.searchParams.delete(key);
            shouldRedirect = true;
        }
    }
    if (!url.searchParams.get("page")) {
        url.searchParams.set("page", "1");
        shouldRedirect = true;
    }
    if (!url.searchParams.get("limit")) {
        url.searchParams.set("limit", "10");
        shouldRedirect = true;
    }
    if (shouldRedirect) {
        throw redirect(url.pathname + "?" + url.searchParams.toString());
    }
    const formData = new FormData();
    formData.append("page", url.searchParams.get("page")!);
    formData.append("limit", url.searchParams.get("limit")!);
    for (const field of fields) {
        appendField(formData, url.searchParams, field);
    }
    const res = await myAxios({
        fileName: "service/readServices.php",
        formData,
        signal: controller.signal,
    });
    if (!res) throw redirect("..");
    return res.data;
}

export async function serviceLoader({ params, request }: LoaderFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const { id } = params;
    if (!id) {
        throw redirect("/Services");
    }
    const formData = new FormData();
    formData.append("id", id);
    const res = await myAxios({
        fileName: "service/readService.php",
        formData,
        signal: controller.signal,
    });
    if (!res || !res.data) throw redirect("..");
    return {
        service: res.data,
    };
}

const urlMap = { Add: "service/createService.php", Edit: "service/updateService.php" };

export async function serviceAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    const action = formData.get("action") as keyof typeof urlMap;
    const url = urlMap[action];
    if (!url) {
        window.alert("Invalid Keyword");
        return null;
    }
    const res = await myAxios({ fileName: url, formData, signal: controller.signal });
    if (!res) return null;
    if (action === "Add") {
        return redirect(`/Services/${res.data.id}`);
    }
    return redirect("..");
}

export async function serviceExportAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const url = new URL(request.url);
    const formData = await request.formData();
    for (const field of fields) {
        appendField(formData, url.searchParams, field);
    }
    const res = await myAxios({
        fileName: "service/exportServices.php",
        formData,
        responseType: "blob",
        signal: controller.signal,
    });
    if (!res) throw redirect(`..?${url.searchParams.toString()}`);
    const disposition = res.headers["content-disposition"];
    let filename = "services.xlsx";
    if (disposition) {
        const match = disposition.match(/filename="?(.+?)"?$/);
        if (match) filename = decodeURIComponent(match[1]);
    }
    saveAs(
        new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        filename
    );
    throw redirect(`..?${url.searchParams.toString()}`);
}

export async function voidServiceAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    if (!formData.get("id")) throw new Response("Missing id", { status: 400 });
    await myAxios({
        fileName: "service/voidService.php",
        formData,
        signal: controller.signal,
    });
    throw redirect("..");
}

export async function validateServiceAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    if (!formData.get("id")) throw new Response("Missing id", { status: 400 });
    await myAxios({
        fileName: "service/validateService.php",
        formData,
        signal: controller.signal,
    });
    throw redirect("..");
}

export async function deleteServiceAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    if (!formData.get("id")) throw new Response("Missing id", { status: 400 });
    const res = await myAxios({
        fileName: "service/deleteService.php",
        formData,
        signal: controller.signal,
    });
    if (!res) throw redirect("..");
    throw redirect("../..");
}
